<a class="page-menu-item" href="{{pageLink}}">
  <img [src]="imageUrl" alt="{{menuItemName}}"/>
  <span>{{menuItemName}}</span>
</a>
